import { DateFormat } from '@/types';
import moment from 'moment';

const DateUtils = {
  formatDateWithoutTime(value: any) {
    const locale = window.navigator.language;
    return value
      ? moment(value)
          .locale(locale)
          .format('L')
      : null;
  },
  isIsoDate(value: string) {
    return moment(value, 'YYYY-MM-DDTHH:mm:ss', true).isValid();
  },
  convertIsoDateToString(value: string) {
    return moment(value, DateFormat.IsoFormat)
      .locale(window.navigator.language)
      .format(DateFormat.UK);
  },
  convertFilterValueToDate(value: string) {
    if (value.includes('/')) {
      const [day, month, year] = value.split('/');
      return new Date(+year, +month - 1, +day);
    } else {
      const [day, month, year] = value.split('-');
      return new Date(+year, +month - 1, +day);
    }
  },
  isValidDate(value: string) {
    try {
      const dateObj = this.convertFilterValueToDate(value);
      return !isNaN(dateObj.getTime());
    } catch {
      return false;
    }
  },
  convertQueueItemValueToDate(value: string) {
    if (!isNaN(Date.parse(value))) {
      return new Date(value).setHours(0);
    }
  }
};

export { DateUtils };
